module.exports = __webpack_public_path__ + "static/g2-winter-performer-96515cf9df317a8e8fd9ce4afbc6dbab.png";